import { createAsyncThunk } from '@reduxjs/toolkit';
import f1IntegrationApi from '@infrastructure/f1-integration-api';
import { getErrorPayload } from '@application/helpers/api-helper';
export const getAllEvents = createAsyncThunk('f1Integration/get', async (_, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.getAllEvents();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventPublicAccessInfo = createAsyncThunk('f1Integration/getEventPublicAccessInfo', async (id, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.getEventPublicAccessInfo(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventStats = createAsyncThunk('f1Integration/getEventStats', async (id, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.getEventStats(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPaginatedInvitationsByEventId = createAsyncThunk('f1Integration/getPaginatedEvents', async (data, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.getPaginatedInvitationsByEventId(data);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const exportToExcelAsync = createAsyncThunk('f1Integration/exportToExcel', async (query, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.exportToExcel(query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllPickupLocations = createAsyncThunk('f1Integration/getPickupLocation', async (_, { rejectWithValue }) => {
    try {
        const response = await f1IntegrationApi.getAllPickupLocations();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
